import hasTrainingPhases from './hasTrainingPhases';

const hasTrainingTracker = (trainingTracker) => {
  const properties = {
    status: trainingTracker.status,
    trainingPhases: trainingTracker.trainingPhases,
    ftoc: trainingTracker.ftoc,
    trainingProgram: trainingTracker.trainingProgram,
    trainingTrackerGuid: trainingTracker.trainingTrackerGuid,
    signActors: trainingTracker.signActors
  };
  return Object.assign(
    properties,
    hasTrainingPhases(trainingTracker.trainingPhases),
  );
};

export default hasTrainingTracker;
